// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"jgp-1N2q1","item":"jgp-2R01S","heading":"jgp-RtEh2","title":"jgp-jVHH5","logo":"jgp-BZfvx"};